import { API_BASE_URL } from './api';
import type { CourseLesson } from '../types/lesson';

export async function fetchModuleLessons(moduleId: string): Promise<CourseLesson[]> {
  const response = await fetch(`${API_BASE_URL}/modules/${moduleId}/lessons`);
  if (!response.ok) {
    throw new Error('Impossible de recuperer les cours du module');
  }
  return (await response.json()) as CourseLesson[];
}

export async function fetchModuleLesson(
  moduleId: string,
  lessonSlug?: string,
): Promise<CourseLesson | null> {
  const lessons = await fetchModuleLessons(moduleId);
  if (lessons.length === 0) {
    return null;
  }
  if (lessonSlug) {
    const match = lessons.find((lesson) => lesson.slug === lessonSlug);
    if (match) {
      return match;
    }
  }
  return lessons[0];
}
